import styled, { css } from 'styled-components/macro'
import Text from 'components/shared/Text'

interface FieldProps {
    isChecked: boolean
    isDisabled?: boolean
    ariaLabelledBy?: string
}

export const Wrapper = styled.div`
    width: 100%;
    &,
    * {
        cursor: pointer;
    }

    ${Text} {
        user-select: none;
    }
`

export const Field = styled.input<FieldProps>`
    &::before {
        width: 24px;
        height: 24px;
        content: '';
        display: block;
        border-radius: 50%;
        border: 2px solid ${({ theme }) => theme.colors.grayscale_400};
        background-color: ${({ theme }) => theme.colors.grayscale_0};
        transition: all 200ms ease-in;

        ${({ isChecked }) =>
            isChecked &&
            css`
                border-color: ${({ theme }) => theme.colors.grayscale_0};
                border-width: 7px;
                background-color: ${({ theme }) => theme.colors.primary_500};
                box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.08);
            `};

        ${({ isDisabled }) =>
            isDisabled &&
            css`
                border-color: ${({ theme }) => theme.colors.grayscale_700};
                border-width: 2px;
                background-color: ${({ theme }) => theme.colors.grayscale_400};
                box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.08);
            `};
    }
`

export const TooltipWrapper = styled.div`
    position: absolute;
    right: 0;
    top: -1px;
`

export const StyledText = styled(Text)`
    padding-right: 32px;
    position: relative;
`
